import '../sass/colors.scss'
import '../css/style.css'
import '../sass/project.scss'
import './components/highlighter.js'
import './components/commentary.js'
import './components/sortableTable.js'
import './components/baseWebSocketClient.js'
import './components/rosterSync.js'
import './components/assignmentGrading.js'
import './components/studentAssignment.js'
import './components/assessmentGrading.js'
import './components/tiptapToolbar.js'
import './components/demoHints.js'
import './components/materialSort.js'

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') document.body.classList.add('tooltips-dismissed')
})
document.addEventListener('pointermove', () =>
  document.body.classList.remove('tooltips-dismissed')
)
;(function focusContentEditableLabels() {
  // Change class of contenteditable_field components label when the div comes into focus

  const contentEditableFields = document.querySelectorAll(
    '.contenteditable-field__field'
  )

  contentEditableFields.forEach(function (field) {
    // Focus event listener
    field.addEventListener('focus', function () {
      // Directly get the label related to this field
      let label = this.parentNode.querySelector('.contenteditable-field__label')
      if (label) {
        label.classList.add('contenteditable-field__label--focus')
      }
    })

    // Blur event listener
    field.addEventListener('blur', function () {
      // Directly get the label related to this field
      let label = this.parentNode.querySelector('.contenteditable-field__label')
      if (label) {
        label.classList.remove('contenteditable-field__label--focus')
      }
    })
  })
})()
;(function preventStudentPasting() {
  // Use capture-phase delegation so editor libraries (TipTap/ProseMirror)
  // cannot process paste before we block it.
  document.addEventListener(
    'paste',
    function (event) {
      if (event.target.closest('.preventPaste')) {
        event.preventDefault()
        event.stopPropagation()
      }
    },
    true
  )
})()
;(() => {
  // Make pencil icon clickable to focus on input field
  const pencilElements = document.querySelectorAll(
    '.contenteditable-field__pencil'
  )
  pencilElements.forEach(function (pencilElement) {
    pencilElement.addEventListener('click', function () {
      const parentDiv = pencilElement.closest('.contenteditable-field')
      const inputField = parentDiv.querySelector(
        '.contenteditable-field__field'
      )
      inputField.focus()
    })
  })
})()
;(() => {
  // Use data-link attribute to navigate to a new page on
  // div clicks without using anchor tags
  var links = document.querySelectorAll('[data-link]')
  for (var i = 0; i < links.length; i++) {
    links[i].addEventListener('click', function (event) {
      var target = event.target
      var excludeLink = false
      while (target !== this) {
        if (target.hasAttribute('data-exclude-link')) {
          excludeLink = true
          break
        }
        target = target.parentNode
      }
      if (!excludeLink) {
        var link = this.getAttribute('data-link')
        window.location.href = link
      }

      event.preventDefault()
    })
  }
})()
;(() => {
  const alertElements = document.querySelectorAll('.alert-perishable')
  // Function to hide each element
  function hideAlerts() {
    alertElements.forEach(function (alert) {
      alert.style.display = 'none'
    })
  }
  setTimeout(hideAlerts, 15000)
})()
;(() => {
  var checkboxes = document.querySelectorAll('.input-checkbox')
  checkboxes.forEach(function (checkbox) {
    checkbox.addEventListener('change', function () {
      checkboxes.forEach(function (checkbox) {
        var parentDiv = checkbox.closest('.flex')
        if (!checkbox.checked) {
          parentDiv.classList.remove('input-container--checked')
        }
      })
      var parentDiv = this.closest('.flex')
      if (this.checked) {
        parentDiv.classList.add('input-container--checked')
      }
    })
  })
})()
